import * as ElementPlusIconsVue from "@element-plus/icons-vue";

export default defineNuxtPlugin((nuxtApp) => {
  Object.entries(ElementPlusIconsVue).forEach(([name, component]) => {
    nuxtApp.vueApp.component(name, component);
  });
});


